import { useInfiniteQuery, UseInfiniteQueryOptions, UseInfiniteQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getMenuSets, IMenuSetsResponseBody } from 'src/api/getMenuSets';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

export const useMenuSets = (
  limit = 50,
  search?: string,
  rangeIds?: string[],
  options?: UseInfiniteQueryOptions<IMenuSetsResponseBody>,
): UseInfiniteQueryResult<IMenuSetsResponseBody> => {
  const { showSnackbar } = useSnackbar();

  return useInfiniteQuery({
    queryKey: [QueryKeys.menuSets, getBrandId(), search, rangeIds],
    queryFn: async ({ pageParam }) => getMenuSets(limit, pageParam, search, rangeIds),
    refetchOnWindowFocus: false,
    onError: () =>
      showSnackbar({ status: SnackbarStatus.ERROR, message: 'Something went wrong whilst fetching menu sets' }),

    getNextPageParam: (lastPage) => lastPage?.paging?.next ?? null,
    ...options,
  });
};
